<template>
  <div class="index">
    <div class="navBox">
      <div v-for="(x,i) in navList" :key="i" class="navLi" :class="{'navAc':navAc===x.type}" @click="navChange(x.type)">{{x.text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['disabled'],
  data() {
    return {
      navList_normal: [
        {text:'企业首页',type:'companyhome'},
        {text:'招聘',type:'zhaopin'},
        {text:'教育',type:'jiaoyu'},
        {text:'培训',type:'peixun'},
        {text:'融资',type:'rongzi'},
        {text:'投资',type:'touzi'},
        {text:'招商',type:'zhaoshang'},
        {text:'加盟',type:'jiameng'},
        {text:'租房',type:'zufang'},
        {text:'售房',type:'shoufang'},
        {text:'汽车',type:'qiche'},
        {text:'电商',type:'gouwu'},
        {text:'美食',type:'meishi'},
        {text:'旅游',type:'lvyou'},
        {text:'健康',type:'jiankang'},
        {text:'用户评价',type:'pingjia'},
      ],
      navList_lvshi: [
        {text:'律师首页',type:'companyhome'},
        {text:'法律咨询',type:'flzx'},
        {text:'案件委托',type:'ajwt'},
        {text:'视频简介',type:'spjj'},
        {text:'视频咨询',type:'spzx'},
        {text:'成功案例',type:'cgal'},
        {text:'用户评价',type:'pingjia'},
      ],
    }
  },
  computed: {
    navAc() {
      return this.$route.query.type
    },
    companyName() {
      return this.$route.query.oname
    },
    navList() {
      if (this.navAc === 'lvshi') {
        return this.navList_lvshi
      } else {
        return this.navList_normal
      }
    }
  },
  methods: {
    navChange(type) {
      if (!this.disabled) {
        let url = '/detailList?type='+type+'&page=1&oname='+this.companyName
        if (this.$route.name === 'detail') {
          this.$router.push(url)
        } else if (this.navAc !== type) {
          this.$router.replace(url)
        }
        this.$emit('navChangeHandler', type)
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.navBox{
  height: 53px;
  line-height: 53px;
  font-size: 16px;
  color: #444444;
  border: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
.navBox .navLi{
  flex: 1;
  text-align: center;
}
.navBox .navLi:hover{
  cursor:pointer;
  color: #1E9FFF;
}
.navAc{
  border-bottom: 1px solid #ff6b6b;
}
</style>